<template>
  <div>
    <div class="slide_bottom_bg" v-show="isShow" @click="closeSheet"></div>
    <transition name="van-slide-up">
        <div class="slide_bottom_wrap" v-show="isShow">
          <van-icon name="clear" @click="closeSheet" class="close" />
          <slot name="content"></slot>
        </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

      }
    },
    methods: {
      closeSheet() {
        this.$emit('update:isShow', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .slide_bottom_bg {
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.7);
    z-index:1;
  }
  .slide_bottom_wrap {
    background:#fff;
    padding:15px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:20;
    overflow-x: hidden;
    overflow-y: auto;
    .close {
      font-size: 21px;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index:1;
    }
  }
</style>
